<div class="form-group-custom">
  <label for="inputCalendarHoliday" class="input-group-zeus__label">Data</label>
  <div class="input-group-custom input-group-custom--icon-prepend input-group-custom--icon-prepend--transparent"
       id="inputCalendarHoliday-dropdown">
    <input type="text" class="form-control-custom" id="inputCalendarHoliday"
           [placeholder]="selectedDateInternal ? (selectedDateInternal | ngbDate:'DD MMM YYYY') : 'Seleziona data'"
           aria-label="Data"
           aria-describedby="basic-addon3"
           (click)="open()" readonly>
    <div class="input-group-custom__prepend input-group-custom__prepend--transparent">
      <span class="input-group-custom__icon input-group-custom__icon--transparent" id="basic-addon2"><i
        class="icon-calendar"></i></span>
    </div>
  </div>
</div>
